import { ProfileHover } from "./ProfileHover"
import { ProfileFixed } from "./ProfileFixed"

const renderStyle = {
  hover: ProfileHover,
  fixed: ProfileFixed,
}

export const ProfileList = ({ profiles, style }) => {
  const Comp = renderStyle[style] || null

  return <Comp profiles={profiles} />
}
